import { startTransition } from 'react';
import { initializeAuth } from '../features/auth/store/authSlice';
import tokenStorage from '../utils/tokenStorage';

/**
 * Read the stored session on mount. The read is a couple of localStorage
 * lookups, so a signed-in user is authenticated before they can tap a
 * service. Guests still resolve inside a transition.
 */
export default function runAuthInit(dispatch) {
  if (tokenStorage.isTokenValid()) {
    dispatch(initializeAuth());
    return;
  }
  startTransition(() => dispatch(initializeAuth()));
}
